export default __webpack_public_path__ + "static/media/tejas-shetty.7573cf9b.jpg";